import {EnvironmentType} from './environment-type';

export const environment: EnvironmentType = {
  name: 'production',
  production: true,
  backendUri: 'https://api.app-v3.hetomegaproject.nl',
  sentryDsn: 'https://3a36e85da8ce5105dfb43ea7ea9ce3d5@o4507583630278656.ingest.de.sentry.io/4507583724585040'
};
